// @flow

/**
 * cfReferenceList
 * This method maps contentful entities.
 * NOTE: This is an extension point, where we're planning
 * to map contentful data to our models.
 * @export
 * @param {Object[]} referenceList
 * @returns {Object[]} mapped referenceList
 */
export function cfReferenceList(referenceList: Array<Object> = []): Array<Object> {
    return referenceList.map((entity) => entity);
}
